import { useEffect, useState } from "react";
import { IconFirstAidKit, IconFlask, IconWorld } from "@tabler/icons-react";
import { storeAssets } from "../../assets";
import styles from "./styles.module.scss";

const bullets = [
  { icon: IconFirstAidKit, text: "Desenvolvido por dermatologistas" },
  { icon: IconFlask, text: "Fórmulas seguras, eficazes e com respaldo científico." },
  { icon: IconWorld, text: "Resultados reais comprovados por milhares de homens." },
];

const SLIDE_COUNT = 2;
const AUTOPLAY_MS = 6000;

export function StoreHero() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const timer = window.setInterval(() => setActive((current) => (current + 1) % SLIDE_COUNT), AUTOPLAY_MS);
    return () => window.clearInterval(timer);
  }, [paused]);

  return (
    <section
      className={styles.hero}
      aria-roledescription="carrossel"
      aria-label="Destaques da loja"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      {Array.from({ length: SLIDE_COUNT }, (_, index) => (
        <div
          className={`${styles.slide} ${index === active ? styles.slideActive : ""}`}
          key={index}
          role="group"
          aria-roledescription="slide"
          aria-label={`${index + 1} de ${SLIDE_COUNT}`}
          aria-hidden={index !== active}
        >
          <div className={styles.inner}>
            <div className={styles.copy}>
              {index === 0
                ? <h1 className={styles.title}>Suplemento capilar testado e aprovado: resultados comprovados!</h1>
                : <h2 className={styles.title}>Suplemento capilar testado e aprovado: resultados comprovados!</h2>}
              <p className={styles.subtitle}>Desenvolvido pela empresa nº 1 do mundo em restauração capilar.</p>
              <ul className={styles.bullets}>
                {bullets.map(({ icon: Icon, text }) => (
                  <li key={text}><Icon size={18} stroke={1.8} aria-hidden="true" />{text}</li>
                ))}
              </ul>
              <a className={styles.cta} href="#produtos" tabIndex={index === active ? undefined : -1}>Comprar agora</a>
            </div>
            <div className={styles.visual}>
              <img
                src={storeAssets.heroSlide}
                alt={index === 0 ? "Vitruvian Line — suplemento capilar Vinci Hair Clinic" : ""}
                width="1248"
                height="1004"
                loading={index === 0 ? "eager" : "lazy"}
                fetchPriority={index === 0 ? "high" : undefined}
                decoding="async"
              />
            </div>
          </div>
        </div>
      ))}

      <div className={styles.dots}>
        {Array.from({ length: SLIDE_COUNT }, (_, index) => (
          <button
            key={index}
            type="button"
            className={`${styles.dot} ${index === active ? styles.dotActive : ""}`}
            onClick={() => setActive(index)}
            aria-label={`Ir para o slide ${index + 1}`}
            aria-current={index === active}
          />
        ))}
      </div>
    </section>
  );
}
